import { z } from 'zod'

export const createWebhookSchema = z.object({
  account_id: z.string({ required_error: 'Account is required' }).uuid('Account is required'),
  label: z
    .string({ required_error: 'Label is required' })
    .min(1, 'Label is required')
    .max(64, 'Label must be 64 characters or less'),
  url: z
    .string({ required_error: 'Destination URL is required' })
    .min(1, 'Destination URL is required')
    .max(1024, 'URL must be 1024 characters or less')
    .url('Invalid URL format (must start with http:// or https://)'),
  method_enum: z.enum(['post', 'get'], {
    required_error: 'Method is required'
  })
})

export type CreateWebhookFormValues = z.infer<typeof createWebhookSchema>

export const editWebhookSchema = z.object({
  label: z
    .string({ required_error: 'Label is required' })
    .min(1, 'Label is required')
    .max(64, 'Label must be 64 characters or less'),
  notes: z
    .string()
    .max(1024, 'Notes must be 1024 characters or less')
    .optional()
    .nullable()
    .or(z.literal('')),
  events: z.array(z.string()).optional().nullable()
})

export type EditWebhookFormValues = z.infer<typeof editWebhookSchema>

// Webhook destination validation schema
export const destinationSchema = z.object({
  url: z
    .string({ required_error: 'Destination URL is required' })
    .min(1, 'Destination URL is required')
    .max(1024, 'URL must be 1024 characters or less')
    .url('Invalid URL format (must start with http:// or https://)'),
  method_enum: z.enum(['post', 'get'], {
    required_error: 'Method is required'
  }),
  is_active: z.boolean().default(true),
  custom_header_name: z
    .string()
    .max(128, 'Header name must be 128 characters or less')
    .optional()
    .nullable()
    .or(z.literal('')),
  custom_header_value: z
    .string()
    .max(128, 'Header value must be 128 characters or less')
    .optional()
    .nullable()
    .or(z.literal(''))
})

export type DestinationFormValues = z.infer<typeof destinationSchema>
